import React from 'react';
import Lazyload from 'react-lazyload';
import './index.css';
import {Webp} from '../formateImage';
let TAB_TYPE = [{
  id: 'attraction',
  text: '景点'
},{
  id: 'food',
  text: '美食'
}];

export default class NextStation extends React.Component {
  render(){
    let { nextStationType, stationList , changeNextStationType, emptyTips} = this.props;
    if(!stationList) return null;
    return (
      <div className="next-station">
        {
          this.props.poiInfo.city_info.region && this.props.poiInfo.city_info.region === 10027 ? null : (
            <div className="station-type">
              {
                TAB_TYPE.map((tab,index)=>{
                  return(
                    <div 
                      key={index}
                      className={tab.id === nextStationType ? 'type-item active' : 'type-item'}
                      onClick={()=>{
                        changeNextStationType(tab.id);
                      }}>
                      {tab.text}
                    </div>
                  );
                })   
              }
            </div>
          )
        }
        <div className="next-station-list-wrap">
          <ul className="next-station-list">
            {
              stationList.length ?
                stationList.map((item, index) =>{
                  return(
                    <Item
                      key={item.poi_uid}
                      item={item}
                      hanldeItemClick={this.hanldeItemClick} />
                  );
                })
                : <div className="no-comments">{emptyTips}</div>
            }
          </ul>
        </div>
      </div>
    );
  }

  hanldeItemClick = (item)=>{
    this.props.handleClickNextStation(item);
  }
  
}

function Item(props){
  let { item, hanldeItemClick } = props;
  let image = `${item.pic_url}!/both/210x160`;
  image = Webp(image);
  return (
    <li className="next-station-item" onClick={()=>{
      hanldeItemClick(item);
    }}>
      <div className="item-inner">
        <div className="next-station-image">
          <Lazyload height={20}>
            <img src={image} alt={item.goods_name}/>
          </Lazyload>
          <div className="tag"><span>{item.line_distance}</span></div>
        </div>
        <div className="next-station-detail">
          <h5 className="next-station-name">{item.cn_name}</h5>
          {item.percent > 0 ? <span className="detail"><b>{item.percent}%</b>人会去</span> : null }
        </div>
      </div>
    </li>
  );
}







// WEBPACK FOOTER //
// ./src/components/Poi2/NextStation/index.js